import { jwtDecode } from "jwt-decode";
import userService from "./user";
import ENDPOINTS from "~/composables/config/routes";

export async function jwtChecker(): Promise<void | string> {
  try {
    const user = getJWTUser();
    if (!user?.token) return;

    const decoded = jwtDecode(user.token) as { exp: number };

    const now = Date.now() / 1000;

    if (now >= decoded.exp) {
      jwtFailure();
      const config = useRuntimeConfig();
      const apiUrl = `${config.public.API_URL}${config.public.USER_ROUTE}${ENDPOINTS.REFRESH_ROUTE}`;

      const token = await userService.refreshToken(apiUrl);
      await new Promise(resolve => setTimeout(resolve, 500));
      return token;
    }
  } catch (err) {
    jwtFailure();
    throw err;
  }
}

export function jwtFailure() {
  const notificationStore = useNotificationStore();
  const authStore = useUserStore();

  notificationStore.error({
    variant: "persistentAlert",
    messageHead:
      "Apologies, you have been logged out due to an authentication error.",
    messageBody: "Please try logging in again or get in touch to find out more."
  });

  authStore.logout();
}
